import './Checkbox.scss';

import type { InputHTMLAttributes, DetailedHTMLProps, FC } from 'react';
import { uniqueId, omit } from 'lodash-es';
import classNames from 'classnames';

type HTMLInputElementProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

interface Props extends HTMLInputElementProps {
  invalid?: boolean;
  testID?: string;
}

export const Checkbox: FC<Props> = (props) => {
  const id = uniqueId('input');

  return (
    <div
      className={classNames('Checkbox', {
        'is-checked': props.checked,
        'is-disabled': props.disabled,
        'is-invalid': props.invalid,
      })}
    >
      <input
        className="Checkbox-input"
        id={id}
        type="checkbox"
        checked={props.checked}
        data-test-id={props.testID}
        onChange={props.onChange}
        {...omit(props, [
          'checked',
          'children',
          'invalid',
          'onChange',
          'className',
          'testID',
        ])}
      />

      <label htmlFor={id}>{props.children}</label>
    </div>
  );
};

export default Checkbox;
